$(document).on('click', '[data-password-show]', (event) => {
  event.preventDefault();
  const pw = document.getElementById('id_password');
  const pw1 = document.getElementById('id_new_password1');
  const pw2 = document.getElementById('id_new_password2');
  const pwold = document.getElementById('id_old_password');

  if (pw !== null) {
    if (pw.type === 'password') {
      pw.type = 'text';
    } else {
      pw.type = 'password';
    }
  }
  if (pw1 !== null && pw2 !== null) {
    if (pw1.type === 'password') {
      pw1.type = 'text';
      pw2.type = 'text';
    } else {
      pw1.type = 'password';
      pw2.type = 'password';
    }
  }
  if (pwold !== null) {
    if (pwold.type === 'password') {
      pwold.type = 'text';
    } else {
      pwold.type = 'password';
    }
  }
});
